import React, { useEffect } from "react";
import SwitchProps from "./Switch.types";
import "./Switch.scss";

const Switch = ({
  activeLabel,
  inactiveLabel,
  activeSection,
  inactiveSection,
  isActiveLeft = "left",
  switchTab = () => {},
}: SwitchProps) => {
  const [isActive, setActive] = React.useState("left");
  useEffect(() => {
    setActive(isActiveLeft);
  }, [isActiveLeft]);
  return (
    <div className="switch-wrapper">
      <div className="switch-cover">
        <div className="switch">
          <span
            aria-hidden="true"
            className={isActive === "left" ? "active" : "inactive"}
            onClick={() => {
              switchTab();
              setActive("left");
            }}
          >
            {activeLabel}
          </span>
          <span
            aria-hidden="true"
            className={isActive === "right" ? "active" : "inactive"}
            onClick={() => {
              switchTab();
              setActive("right");
            }}
          >
            {inactiveLabel}
          </span>
        </div>
        <div className="switch-body">
          {isActive === "left" ? activeSection : inactiveSection}
        </div>
      </div>
    </div>
  );
};

export default Switch;
